import { ButtonVariant, CoButton } from "components/CoButton";
import Popover from "components/Popover";
import SnapshotTooltip from "components/Popover/SnapshotTooltip";
import Tooltip from "components/Tooltip";
import React, { useState } from "react";
import { CreditedFeature } from "store/slices/subscription";

interface SnapshotButtonProps {
  isPremium: boolean;
  isStudySnapshotExpanded: boolean;
  setIsStudySnapshotExpanded: (expanded: boolean) => void;
  searchLabels: Record<string, string>;
}

export const SnapshotButton: React.FC<SnapshotButtonProps> = ({
  isPremium,
  isStudySnapshotExpanded,
  setIsStudySnapshotExpanded,
  searchLabels,
}) => {
  const [tooltipInstance, setTooltipInstance] = useState<any>(null);

  const handleClickUpgradePremium = (e: React.MouseEvent<HTMLElement>) => {
    if (tooltipInstance) {
      tooltipInstance.hide();
    }
  };

  if (isPremium) {
    const tooltipContent = isStudySnapshotExpanded
      ? searchLabels["close-snapshot"]
      : searchLabels["expand-study-snapshot"];

    return (
      <Tooltip content={tooltipContent} placement="bottom">
        <CoButton
          size="sm"
          variant={ButtonVariant.Flat}
          onClick={() => {
            setIsStudySnapshotExpanded(!isStudySnapshotExpanded);
          }}
          icon="icon-table-2"
          iconRight={
            isStudySnapshotExpanded ? "icon-chevron-up" : "icon-chevron-down"
          }
        />
      </Tooltip>
    );
  }

  return (
    <Popover
      interactive
      maxWidth={334}
      touch={false}
      tooltipContent={
        <SnapshotTooltip
          snapshotType={CreditedFeature.STUDY_SNAPSHOT}
          onClickUpgradePremium={handleClickUpgradePremium}
        />
      }
      onShown={(instance: any) => {
        setTooltipInstance(instance);
      }}
      onHidden={(instance: any) => {
        setTooltipInstance(instance);
      }}
    >
      <CoButton
        size="sm"
        variant={ButtonVariant.Flat}
        onClick={() => {
          setIsStudySnapshotExpanded(!isStudySnapshotExpanded);
        }}
        icon="icon-table-2"
        iconRight={
          isStudySnapshotExpanded ? "icon-chevron-up" : "icon-chevron-down"
        }
      />
    </Popover>
  );
};
